if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        const isBundlePage = document.querySelector('custom-switch');
        if (isBundlePage) {
          this.form.addEventListener('submit', this.handleBundleSubmit.bind(this));
        } else if (theme.settings.afterAtc !== 'no-js') {
          this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }
    }

    handleBundleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;
      evt.preventDefault();

      const GroupID = Date.now().toString();
      const form = evt.target.closest('form');
      let sections = 'cart-icon-bubble';
      let objectsArray = [];
      let properties = {};
      let hasErrors = false;

      const quantity = parseInt(form.querySelector("input[name='quantity']").value) || 1;
      const mainProductId = parseInt(document.querySelector('custom-switch').getAttribute('id'));

      const mainProduct = {
        id: mainProductId,
        quantity: quantity,
        properties: properties
      };

      const gangWrapper = document.querySelector('.first_step');
      let no_of_gang = 0;
      if (gangWrapper) {
        const sizeInput = gangWrapper.querySelector('.size_flex.active input:checked');
        if (sizeInput) no_of_gang = parseInt(sizeInput.dataset.gang) || 0;
      }

      const colorVariants = document.querySelector('.color_switch_variant.active');
      if (colorVariants) {
        const selectedColor = colorVariants.querySelector('input:checked:not(:disabled)');
        if (selectedColor) {
          const selectedPlateId = selectedColor.getAttribute('data-id');

          objectsArray.push({
            id: parseInt(selectedPlateId),
            quantity: quantity,
            properties: { Group_ID: GroupID }
          });

          const bundlePriceEl = document.querySelector('#bundle-price');
          if (bundlePriceEl) properties['Bundle Price'] = bundlePriceEl.value || '';

          properties['Plate Color'] = selectedColor.closest('.item_col').dataset.prop || '';
          properties['Plate Size'] = `${no_of_gang + 1} Gang`;

          const warningEl = colorVariants.closest('.second_step');
          if (warningEl) {
            const w = warningEl.querySelector('.warning_text');
            if (w) w.remove();
          }
        } else {
          hasErrors = true;
          if (window.BYOConfigurator) {
            window.BYOConfigurator.showError('Please select a plate color.');
            window.BYOConfigurator.goToStep('color');
          }
        }
      }

      const moduleLines = (window.BYOConfigurator && typeof window.BYOConfigurator.getModuleLineItems === 'function')
        ? window.BYOConfigurator.getModuleLineItems()
        : [];
      const requiredModules = (window.BYOConfigurator && typeof window.BYOConfigurator.getRequiredModuleCount === 'function')
        ? window.BYOConfigurator.getRequiredModuleCount()
        : (no_of_gang + 1);

      if (!moduleLines.length || moduleLines.length !== requiredModules) {
        hasErrors = true;
        if (window.BYOConfigurator) {
          window.BYOConfigurator.showError('Please select all modules before adding to cart.');
          if (!colorVariants || colorVariants.querySelector('input:checked:not(:disabled)')) {
            window.BYOConfigurator.goToStep('modules');
          }
        }
      } else {
        moduleLines.forEach((line, index) => {
          objectsArray.push({
            id: parseInt(line.id, 10),
            quantity: quantity,
            properties: { Group_ID: GroupID }
          });
          properties[`Module ${index + 1}`] = `${line.prop} / ${line.sku}`;
        });
      }

      if (hasErrors) {
        this.submitBtn.setAttribute('aria-disabled', 'false');
        this.submitBtn.classList.remove('is-loading');
        return;
      }

      if (window.BYOConfigurator) window.BYOConfigurator.hideError();

      properties['Group_ID'] = GroupID;
      objectsArray.unshift(mainProduct);

      const formData = { items: objectsArray };

      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }
      formData.sections_url = `${window.location.pathname}?drawer_pass=core`;
      formData.sections = sections;

      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      })
        .then(response => {
          if (!response.ok) {
            this.submitBtn.setAttribute('aria-disabled', 'false');
            this.submitBtn.classList.remove('is-loading');
            return response.json().then(err => {
              throw new Error(err.message || 'Something went wrong');
            });
          }
          return response.json();
        })
        .then(async (state) => {
          this.submitBtn.setAttribute('aria-disabled', 'false');
          this.submitBtn.classList.remove('is-loading');
          const cart = document.querySelector('cart-drawer');
          if (cart) {
            const opener = this.closest('quick-add-drawer') ? null : this.submitBtn;
            await cart.hydrateAfterAdd(state, { openDrawer: true, opener });
          }
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: state,
              variantId: state.items?.[0]?.variant_id
            }
          }));
        })
        .catch(error => {
          console.error('Bundle add to cart error:', error);
          this.submitBtn.setAttribute('aria-disabled', 'false');
          this.submitBtn.classList.remove('is-loading');
        });
    }

    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      let sections = 'cart-icon-bubble';
      const formData = new FormData(this.form);

      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }
      formData.append('sections_url', `${window.location.pathname}?drawer_pass=core`);
      formData.append('sections', sections);

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      try {

  // 1. Add to cart (only 1 fetch!)
  const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
  const data = await response.json();

  if (!response.ok) {
    let error = typeof data.description === 'string' ? data.description : data.message;
    if (data.errors && typeof data.errors === 'object') {
      error = Object.entries(data.errors).map(item => item[1].join(', '));
    }
    this.setErrorMsgState(error);
    throw new Error(response.status);
  }

  // Quick Add: notification only — cart open is handled by hydrateAfterAdd
  const quickAddDrawer = this.closest('quick-add-drawer');
  if (quickAddDrawer) quickAddDrawer.addedToCart();

  const openDrawer = !!quickAddDrawer || theme.settings.afterAtc === 'drawer';

  if (this.cartDrawer) {
    // The quick-add drawer closes, so its button can't take focus back.
    const opener = quickAddDrawer ? null : this.submitBtn;
    await this.cartDrawer.hydrateAfterAdd(data, { openDrawer, opener });
  } else if (window.location.pathname === theme.routes.cart) {
    const cartItems = document.querySelector('cart-items');
    if (cartItems) {
      if (cartItems.dataset.empty === 'true') {
        window.location.reload();
      } else {
        cartItems.refresh();
      }
    }
  }

  // Announce success to screen readers (WCAG 4.1.3) — the visual "added"
  // state on the button is not conveyed programmatically otherwise.
  this.announceAtcSuccess();

  // Dispatch event
  this.dispatchEvent(new CustomEvent('on:cart:add', {
    bubbles: true,
    detail: {
      cart: data,
      variantId: data.variant_id
    }
  }));

} catch (error) {
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg?.textContent
          }
        }));

        if (this.cartDrawer) this.cartDrawer.refresh(true);
      } finally {
        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);
      }
    }

    /**
     * Announces "Added to cart" on a polite status region (WCAG 4.1.3).
     */
    announceAtcSuccess() {
      let status = this.querySelector('.js-atc-status');
      if (!status) {
        status = document.createElement('span');
        status.className = 'js-atc-status visually-hidden';
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
        this.appendChild(status);
      }
      status.textContent = (theme.strings && theme.strings.addedToCart) || 'Added to cart';
      clearTimeout(this._atcStatusTimeout);
      this._atcStatusTimeout = setTimeout(() => { status.textContent = ''; }, 3000);
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer?.constructor?.updateCartIcon) {
        cartDrawer.constructor.updateCartIcon(response);
        return;
      }

      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble && response.sections?.['cart-icon-bubble']) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);
}

